import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import Svg, { SvgEnum } from "../../ui library/components/svgs/standard/svg";

import ActionButtonList from "./components/ActionButtons/ActionButtonList";

export const Banner = () => {
  const navigate = useNavigate();
  return (
    <div className="flex w-full min-w-fit flex-col justify-evenly">
      <div
        data-testid="banner-gradient-2"
        style={{
          position: "relative",
          overflow: "hidden",
          background: "linear-gradient(90.21deg, #6F1F94 0%, #2D1F96 82.21%, #2B9AE7 100%)",
        }}
        className="flex h-16 w-full min-w-fit flex-row items-center justify-between"
      >
        <div onClick={() => navigate("/dashboard")}>
          <Svg name={SvgEnum.HisLogo} sx={{ width: "145px", marginLeft: "70px" }} />
        </div>
        <div className="flex flex-row gap-64">
          <Typography className="text-center capitalize text-white" style={{ fontSize: "1.1rem" }}>
            Wellness, Simplified.
          </Typography>
          <Svg
            name={SvgEnum.Particles1}
            sx={{
              position: "absolute",
              right: "-53px",
              top: "-23px",
              width: "82%",
            }}
          />
          <Svg
            name={SvgEnum.Particles2}
            sx={{
              position: "absolute",
              right: "112px",
              top: "-101px",
              width: "90%",
            }}
          />
          {/*<Svg name={SvgEnum.Particles3} sx={{*/}
          {/*  position: 'absolute',*/}
          {/*  right: '304px',*/}
          {/*  top: '-42px',*/}
          {/*  width: '66%',*/}
          {/*}} />*/}
          <ActionButtonList />
        </div>
      </div>
    </div>
  );
};
